//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import PwrReset from './PwrReset.vue';

const bus = new Vue();

export default {
  name: 'PwrForm',
  components: { PwrReset },
  provide: {
    bus,
  },
  props: {
    disableSubmitWhenUnmodified: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    resetText: {
      type: String,
      default: 'Reset',
    },
    resetVariant: {
      type: String,
      default: 'secondary',
    },
    showReset: {
      type: Boolean,
      default: false,
    },
    showSubmit: {
      type: Boolean,
      default: true,
    },
    submitText: {
      type: String,
      default: 'Submit',
    },
    submitVariant: {
      type: String,
      default: 'primary',
    },
  },
  data: function data() {
    return {
      invalidElements: [],
      fields: [],
      bus,
    };
  },
  computed: {
    isValid() {
      this.fields.forEach((field) => {
        try {
          field.validate();
        } catch (e) {
          // ignore
        }
      });
      return this.invalidElements.length === 0;
    },
    submitDisabled() {
      return this.loading
        || this.invalidElements.length > 0
        || (this.disableSubmitWhenUnmodified && !this.isModified);
    },
    resetDisabled() {
      return this.loading || (this.disableSubmitWhenUnmodified && !this.isModified);
    },
    isModified() {
      for (let i = 0; i < this.fields.length; i += 1) {
        if (this.fields[i].$v && this.fields[i].$v.$dirty) {
          return true;
        }
      }
      return false;
    },
  },
  created() {
    this.bus.$on('pwr-form-invalid', this.handleInvalid);
    this.bus.$on('pwr-form-valid', this.handleValid);
    this.bus.$on('pwr-form-register', this.handleRegister);
    this.bus.$on('reset', () => this.$emit('reset'));
  },
  methods: {
    handleValid(message) {
      const index = this.invalidElements.indexOf(message);
      if (index >= 0) {
        this.invalidElements.splice(index);
      }
      this.$emit('is-valid', this.invalidElements.length === 0);
    },
    handleInvalid(message) {
      if (this.invalidElements.indexOf(message.field) === -1) {
        this.invalidElements.push(message.field);
      }
      this.$emit('is-valid', false);
    },
    handleRegister(vm) {
      this.fields.push(vm);
    },
    resetValidation() {
      for (let i = 0; i < this.fields.length; i += 1) {
        if (this.fields[i].$v) {
          this.fields[i].$v.$reset();
        }
      }
    },
  },
};
